<div class="modal-header">
    <button type="button" class="close" (click)="onClose()">&times;</button>
  </div>
  
  <div class="modal-body">
    <form (ngSubmit)="submitForm()" #form="ngForm">
      <div class="add_category_cnt">
        <label>Service Type :</label>
        <input type="text" [(ngModel)]="staffData.serviceType" name="serviceType" class="form-control" required />
      </div>
      <div class="add_category_cnt">
        <label>Organisation Name :</label>
        <input type="email" [(ngModel)]="staffData.organisationName" name="organisationName" class="form-control" required />
      </div>
      <div class="add_category_cnt">
        <label>Contact Person :</label>
        <input type="text" [(ngModel)]="staffData.contactPerson" name="contactPerson" class="form-control" required />
      </div>
      <div class="add_category_cnt">
        <label>Mobile Number :</label>
        <input type="text" [(ngModel)]="staffData.mobileNumber" name="mobileNumber" class="form-control" required />
      </div>
      <div class="add_category_cnt">
        <label>Email Id :</label>
        <input type="text" [(ngModel)]="staffData.emailId" name="emailId" class="form-control" />
      </div>
      <div class="add_category_cnt">
        <label>City :</label>
        <input type="text" [(ngModel)]="staffData.city" name="city" class="form-control" />
      </div>
      <div class="add_category_cnt">
        <label>Security Deposit:</label>
        <input type="text" [(ngModel)]="staffData.securityDeposit" name="securityDeposit" class="form-control" />
      </div>
      <div class="add_category_cnt">
        <label>Date:</label>
        <input type="text" [(ngModel)]="staffData.date" name="date" class="form-control"/>
      </div>
      <div class="add_category_cnt mt-3">
        <button type="submit" class="btn btn-primary">Submit</button>
      </div>
    </form>
  </div>
  